import React, { useState } from 'react';
import { Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import '../../custom.scss';
import Logo from '../../img/ahrqi-logo.png'
import { NavLink, useRouteMatch } from 'react-router-dom'
import { Link } from 'react-router-dom'
import MenuData from './menu';
import { useMediaQuery } from 'react-responsive';
import ArrowIcon from '../../img/arrow-down.svg';

const Navigation = () => {
    let loc = window.location.pathname;
    const handleClick = (event) => event.preventDefault();
    const matchHome = useRouteMatch("/home");
    const matchMeasures = useRouteMatch("/measures");
    const matchSoftware = useRouteMatch("/software");
    const matchResources = useRouteMatch("/resources");
    const matchArchives = useRouteMatch("/archive");
    const [isDropShown, setDropShown] = useState(false);
    const [isNavbarExpanded, setNavbarExpanded] = useState(false);
    const navbarExpanded = (state) => () => {
        setNavbarExpanded(state);
    };


    return (<>
        <Navbar collapseOnSelect id="responsive-navbar-nav" expand="xl" className="navbar-main" variant="dark" >
            {useMediaQuery({ query: `(max-width: 1200px)` }) ?
                <>
                    <Container>
                        <Navbar.Brand>
                            <Link to="/">
                                <img src={Logo} />
                            </Link>
                        </Navbar.Brand>

                        <Navbar.Toggle onClick={navbarExpanded(true)} aria-controls="responsive-navbar-nav" />
                    </Container>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav variant="pills" className="main-nav">
                            {MenuData.map((item, index) => {
                                return (<>
                                    {item.submenu.length === 0 ?
                                        (
                                            <Nav.Item className='fullwidth mobile-nav-border' >
                                                <Nav.Link eventKey={index}>
                                                    <NavLink eventKey={index} className='fullwidth' exact activeClassName="active" to={item.path}>
                                                        <Container>
                                                            <NavLink eventKey={index} className="mobile-nav-link" key={index} to={item.path}>
                                                                {item.title}
                                                            </NavLink>
                                                        </Container>
                                                    </NavLink>
                                                </Nav.Link>
                                            </Nav.Item>
                                        )

                                        :
                                        (<Dropdown className="mobile-dropdown" key={index} >
                                            <NavLink activeClassName="active" onClick={(e) => e.preventDefault()} to={item.path}>
                                                <div className='fullwidth mobile-nav-border'>
                                                    <Container>
                                                        <div className={'mobile-dropdown-nav-items'}>
                                                            <Nav.Item className={'mobile-dropdown-nav-items-item'}>
                                                                <Nav.Link eventKey={index}>
                                                                    <NavLink className="mobile-nav-link" key={index} to={item.path}>{item.title}</NavLink>
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                            <Dropdown.Toggle className={"main-nav-dropdown"}></Dropdown.Toggle>
                                                        </div>
                                                    </Container>
                                                </div>
                                            </NavLink>
                                            <Dropdown.Menu className={'mobile-nav-dropdown-menu'}>
                                                {item.submenu.map((subItem, index) => {
                                                    return (<>
                                                        <div className='mobile-nav-dropdown-container'>
                                                            <Nav.Item className={'mobile-sub-nav-item'}>
                                                                <Nav.Link eventKey={subItem.subtitle}>
                                                                    <Container >
                                                                        <Dropdown.Item className='mobile-nav-dropdown-item' key={index} as={NavLink} to={subItem.path}>{subItem.subtitle}</Dropdown.Item>
                                                                    </Container>
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        </div>
                                                    </>)
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>)

                                    }
                                </>)
                            })}
                        </Nav>
                    </Navbar.Collapse>
                </>

                : <>
                    <Container>
                        <Navbar.Brand>
                            <Link to="/">
                                <img src={Logo} />
                            </Link>
                        </Navbar.Brand>

                        <Navbar.Toggle />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav variant="pills" className="main-nav">
                                {MenuData.map((item, index) => {
                                    return (<>
                                        {item.submenu.length === 0 ?
                                            (<NavLink key={index} className="main-nav-link " exact activeClassName="active" to={item.path}>{item.title}</NavLink>)
                                            :
                                            (<Dropdown show={isDropShown === index} onFocus={() => setDropShown(index)} onMouseEnter={() => setDropShown(index)} onMouseLeave={() => setDropShown(false)} key={index} >
                                                <NavLink activeClassName="active" to={item.path}>
                                                    <Dropdown.Toggle eventKey="home" onClick={() => setDropShown(false)} className={"main-nav-dropdown"}>{item.title}</Dropdown.Toggle>
                                                </NavLink>
                                                <Dropdown.Menu className={'main-nav-dropdown-menu'}>
                                                    {item.submenu.map((subItem, index) => {
                                                        return (<>
                                                            <Dropdown.Item key={index} onClick={() => setDropShown(false)} as={NavLink} to={subItem.path}>{subItem.subtitle}</Dropdown.Item>
                                                        </>)
                                                    })}
                                                </Dropdown.Menu>
                                            </Dropdown>)

                                        }
                                    </>)
                                })}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </>
            }
        </Navbar>

        {
            matchHome ?
                <>
                    <Navbar className="navbar-sub" expand="lg" variant="dark" >
                        <Navbar.Toggle className="sub-nav-toggle" aria-controls="responsive-navbar-subnav" >
                            <div className={'expand-menu'} >
                                <div className="menu-text">Menu</div>
                                <div className='arrow-icon'><img src={ArrowIcon} /></div>
                            </div>

                        </Navbar.Toggle>
                        <Navbar.Collapse id="responsive-navbar-subnav">
                            <Nav variant="pills" activeKey="home" className="sub-nav">
                                <NavLink exact activeClassName="active" to="/home/about">About Us</NavLink>
                                <NavLink exact activeClassName="active" to="/home/contact">Contact Us</NavLink>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </> : null
        }
        {
            matchMeasures ? <>
                <Navbar className="navbar-sub" expand="lg" variant="dark" >
                    <Navbar.Toggle className="sub-nav-toggle" aria-controls="responsive-navbar-subnav" >
                        <div className={'expand-menu'} >
                            <div className="menu-text">Menu</div>
                            <div className='arrow-icon'><img src={ArrowIcon} /></div>
                        </div>

                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-subnav">
                        <Nav variant="pills" activeKey="measures" className="sub-nav">
                            <NavLink exact activeClassName="active" to="/measures/qi_resources">QI Resources</NavLink>
                            <NavLink exact activeClassName="active" to="/measures/pqi_resources">PQI Resources</NavLink>
                            <NavLink exact activeClassName="active" to="/measures/iqi_resources">IQI Resources</NavLink>
                            <NavLink exact activeClassName="active" to="/measures/psi_resources">PSI Resources</NavLink>
                            <NavLink exact activeClassName="active" to="/measures/pdi_resources">PDI Resources</NavLink>
                            <NavLink exact activeClassName="active" to="/measures/all_measures">All Measures</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </> : null
        }
        {
            matchSoftware ? <>

                <Navbar className="navbar-sub" expand="lg" variant="dark" >
                    <Navbar.Toggle className="sub-nav-toggle" aria-controls="responsive-navbar-subnav" >
                        <div className={'expand-menu'} >
                            <div className="menu-text">Menu</div>
                            <div className='arrow-icon'><img src={ArrowIcon} /></div>
                        </div>

                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-subnav">
                        <Nav variant="pills" activeKey="software" className="sub-nav">
                            <NavLink exact activeClassName="active" to="/software/qi">QI Software</NavLink>
                            <NavLink exact activeClassName="active" to="/software/sas_qi">SAS QI®</NavLink>
                            <NavLink exact activeClassName="active" to="/software/win_qi">WinQI</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </> : null
        }
        {
            matchResources ? <>
                <Navbar className="navbar-sub" expand="lg" variant="dark" >
                    <Navbar.Toggle className="sub-nav-toggle" aria-controls="responsive-navbar-subnav" >
                        <div className={'expand-menu'} >
                            <div className="menu-text">Menu</div>
                            <div className='arrow-icon'><img src={ArrowIcon} /></div>
                        </div>

                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-subnav">
                        <Nav variant="pills" activeKey="resources" className="sub-nav">
                            <NavLink exact activeClassName="active" to="/resources/webinars">Webinars</NavLink>
                            <NavLink exact activeClassName="active" to="/resources/case_studies">Case Studies</NavLink>
                            <NavLink exact activeClassName="active" to="/resources/presentations">Presentations</NavLink>
                            <NavLink exact activeClassName="active" to="/resources/publications">Publications</NavLink>
                            <NavLink exact activeClassName="active" to="/resources/toolkits">Toolkits</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </> : null
        }
        {
            matchArchives ? <>
                <Navbar className="navbar-sub" expand="lg" variant="dark" >
                    <Navbar.Toggle className="sub-nav-toggle" aria-controls="responsive-navbar-subnav" >
                        <div className={'expand-menu'} >
                            <div className="menu-text">Menu</div>
                            <div className='arrow-icon'><img src={ArrowIcon} /></div>
                        </div>

                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-subnav">
                        <Nav variant="pills" activeKey="archives" className="sub-nav">
                            <NavLink exact activeClassName="active" to="/archive/qi_modules">QI Modules</NavLink>
                            <NavLink exact activeClassName="active" to="/archive/news">News</NavLink>
                            <NavLink exact activeClassName="active" to="/archive/software">Software</NavLink>
                            <NavLink exact activeClassName="active" to="/archive/resources">Resources</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </> : null
        }


    </>)
}

export default Navigation;